import * as tslib_1 from "tslib";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import PageSelectMotail from "../page-select-motail/page-select-motail.vue";
import filterCard from "../../../../../list/src/components/pc/components/filter-card/filter-card.vue";
import { Button, Tooltip, Popover } from "@h3/antd-vue";
let PageHeader = class PageHeader extends Vue {
    constructor() {
        super(...arguments);
        this.isShow = false;
        this.current = 0;
        //二开 开始
        this.IsChopAdmin = false;
        //二开 结束
        this.isShowTab = true;
    }
    getDataType(val) {
        switch (val.type) {
            case 5:
                break;
            case 7:
                // this.current = val.isChange?this.current:1;
                break;
        }
    }
    onSearch() {
        this.$emit("search");
    }
    changeTabs(item) {
        this.current = item.key;
        const obj = {
            instanceState: item.value,
        };
        this.$emit("changeTabs", obj);
    }
    searchWorkitems(obj) {
        /**
         * 我的流程
         */
        if (this.headerData.type === 5) {
            // @ts-ignore
            obj.instanceState = this.tabsList[this.current];
        }
        this.$emit("search", obj);
        this.isShow = false;
    }
    /**
     * 清空关键字
     */
    clearKeyword() {
        // @ts-ignore
        this.$refs.child.clearKeyword();
    }
    /**
     * 批量处理
     */
    batchProcess(type) {
        this.$emit("batch", { type: type });
    }
    created() {
        const userInfo = JSON.parse(window.sessionStorage.getItem("user"));
        if (userInfo.roleName.includes("Chop Admin")) {
            this.IsChopAdmin = true;
        }
        // this.getUrl();
    }
    getUrl() {
        const url = window.location.href;
        const showLog = this.getCaption(url, "/");
        this.isShowTab = showLog == "my-unfinished-workitem" ? false : true;
    }
    // 截取地址栏参数
    getCaption(url, parameter) {
        const index = url.lastIndexOf(parameter);
        url = url.substring(index + 1, url.length);
        return url;
    }
};
tslib_1.__decorate([
    Prop({
        default: {
            total: 0,
            showTotal: 0,
            type: 1,
            batch: false,
            queryConditionSource: [],
        },
    })
], PageHeader.prototype, "headerData", void 0);
tslib_1.__decorate([
    Prop({ default: true })
], PageHeader.prototype, "showSummary", void 0);
tslib_1.__decorate([
    Prop({ default: "我的待办" })
], PageHeader.prototype, "subTitle", void 0);
tslib_1.__decorate([
    Prop({ default: [] })
], PageHeader.prototype, "queryConditionSource", void 0);
tslib_1.__decorate([
    Prop({ default: true })
], PageHeader.prototype, "disabled", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], PageHeader.prototype, "isShowBatchTransfer", void 0);
tslib_1.__decorate([
    Prop({ default: () => [] })
], PageHeader.prototype, "tabsList", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], PageHeader.prototype, "queryActive", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], PageHeader.prototype, "isOpen", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], PageHeader.prototype, "noData", void 0);
tslib_1.__decorate([
    Watch("headerData")
], PageHeader.prototype, "getDataType", null);
PageHeader = tslib_1.__decorate([
    Component({
        name: "page-header",
        components: {
            AButton: Button,
            PageSelectMotail,
            filterCard,
            ATooltip: Tooltip,
            APopover: Popover,
        },
    })
], PageHeader);
export default PageHeader;
